import CityPageTemplate from './CityPageTemplate';

export default function SanfordPage() {
  return (
    <CityPageTemplate
      city="Sanford"
      county="Seminole"
      slug="sanford"
      zipCodes={['32771', '32773']}
      neighborhoods={['Historic Downtown Sanford', 'Lake Monroe Waterfront', 'Seminole Towne Center area', 'Goldsboro', 'Midway']}
      localContext="From the revitalized Historic Downtown Sanford waterfront to the neighborhoods along Lake Monroe, we keep Sanford homes and businesses sparkling clean."
      metaDescription="Professional residential and commercial cleaning services in Sanford, FL. Serving ZIP codes 32771 & 32773. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
